import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";


export const useFetchAuditCaseReport = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/listReport`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchPassImportInputAudit = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/pass`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchFailImportInputAudit = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/fail`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchListCase1 = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/listCase1`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchListCase2 = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/listCase2`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchGetAuditCase = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/getCase`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchEditAuditCase = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/edit`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchMapInputAudit = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit/mapInputAudit`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};